<template>
  <!-- MODAL GERAR DOCUMENTO -->
  <div
    class="modal fade"
    id="gerar-documento-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    style="margin-top: 30px"
    @click.self="cancelModal"
    @keydown.esc="cancelModal"
  >
    <form @submit.prevent>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true" @click="cancelModal">&times;</button>
            <h4>Gerar documentos</h4>
            <br />
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">Leilão - Lote</h3>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-2">
                    <div class="form-group">
                      <label for="cpf_cnpj">Leilao ID</label>
                      <input disabled class="form-control" v-model="leilao.id" />
                    </div>
                  </div>
                  <div class="col-sm-2">
                    <div class="form-group">
                      <label for="cpf_cnpj">Leilao tipo</label>
                      <input disabled class="form-control destaque" v-model="leilao.leilao_tipo" style="text-transform: uppercase" />
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label for="cpf_cnpj">Leilão título</label>
                      <input disabled class="form-control" v-model="leilao.leilao_titulo" />
                    </div>
                  </div>

                  <div class="col-sm-4">
                    <div class="form-group">
                      <label>Comitente</label>

                      <select style="text-transform: uppercase" disabled class="custom-select rounded-0" id="comitente" v-model="comitente_id">
                        <option value=""></option>
                        <option v-for="comitente in comitentes" :key="comitente" :value="comitente.id">
                          {{ comitente.nome }} - {{ comitente.cidade }}/{{ comitente.estado }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="col-sm-2" v-if="lotes">
                    <div class="form-group">
                      <label for="cpf_cnpj">Lote ID</label>
                      <input v-if="lotes" disabled class="form-control" v-model="lotes.id" />
                    </div>
                  </div>

                  <div class="col-sm-2">
                    <div class="form-group">
                      <label for="cpf_cnpj">Lote número</label>
                      <input disabled class="form-control" v-model="lotes.lote_numero" style="text-transform: uppercase" />
                    </div>
                  </div>

                  <div class="col-sm-4" v-if="lotes">
                    <div class="form-group">
                      <label for="cpf_cnpj">Lote título</label>
                      <input disabled class="form-control" :value="lotes.lote_titulo" style="text-transform: uppercase" />
                    </div>
                  </div>

                  <div class="col-sm-2" v-if="lotes">
                    <div class="form-group">
                      <label for="cpf_cnpj">Lote status</label>

                      <select style="text-transform: uppercase" disabled class="custom-select rounded-0" v-model="lotes.lote_status">
                        <option value="ativo">Ativo</option>
                        <option value="retirado">Retirado</option>
                        <option value="sem_licitante">Sem licitante</option>
                        <option value="suspenso">Suspenso</option>
                        <option value="vendido">Vendido</option>
                        <option value="vendido_condicional">Vendido condicional</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-sm-2" v-if="lotes">
                    <div class="form-group">
                      <label for="cpf_cnpj">Lote tipo</label>
                      <input disabled class="form-control destaque" v-model="lotes.lote_tipo" style="text-transform: uppercase" />
                    </div>
                  </div>

                  <div class="col-sm-12" v-if="lotes">
                    <div class="form-group">
                      <label for="cpf_cnpj">Lote descrição</label>

                      <textarea
                        disabled
                        class="form-control"
                        :value="htmlParaTexto(lotes.lote_descricao)"
                        rows="2"
                        cols="50"
                        style="text-transform: uppercase"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card">
              <div class="card-header">
                <h3 class="card-title">Dados do titular</h3>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-2" v-if="lotes.users">
                    <div class="form-group">
                      <label for="cpf_cnpj">Arrematante ID</label>
                      <input disabled class="form-control" v-model="lotes.lote_lance_user_id" />
                    </div>
                  </div>
                  <div class="col-sm-2" v-if="lotes.cadastros">
                    <div class="form-group">
                      <label for="cpf_cnpj">Arrematante tipo</label>
                      <input disabled class="form-control destaque" v-model="lotes.cadastros.cadastro_tipo" style="text-transform: uppercase" />
                    </div>
                  </div>
                  <div class="col-sm-4" v-if="lotes.cadastros">
                    <div class="form-group">
                      <label for="cpf_cnpj">Arrematante nome</label>
                      <input
                        v-if="lotes.cadastros.cadastro_tipo == 'pf'"
                        disabled
                        class="form-control"
                        v-model="lotes.cadastros.nome_completo"
                        style="text-transform: uppercase"
                      />
                      <input v-else disabled class="form-control" v-model="lotes.cadastros.pj_razao_social" style="text-transform: uppercase" />
                    </div>
                  </div>
                  <div class="col-sm-2" v-if="lotes.users">
                    <div class="form-group">
                      <label for="cpf_cnpj">Arrematante apelido</label>
                      <input disabled class="form-control" v-model="lotes.users.apelido" style="text-transform: uppercase" />
                    </div>
                  </div>
                  <div class="col-sm-2" v-if="lotes.cadastros">
                    <div class="form-group">
                      <label for="cpf_cnpj">Arrematante estado civil</label>
                      <input disabled class="form-control destaque" v-model="lotes.cadastros.estado_civil" style="text-transform: uppercase" />
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-group">
                      <label for="cpf_cnpj">Segundo arrematante</label>
                      <select disabled class="custom-select rounded-0" id="endereco_estado" v-model="segundo_lance">
                        <option v-for="(lance, indice) in lances" :value="lance" :key="lance">
                          <!--{{ total_lances_indice - (indice + 1) }} - {{ lance.nome_tag }}
                          <span v-if="lance.deleted_at" style="margin-left: 5px">(Cancelado)</span>-->
                          {{ lance.nome_tag }} - R$ {{ toCurrency(lance.valor) }}
                          <span v-if="lance.user_cadastros">&nbsp;- {{ lance.user_cadastros.nome_completo }}</span>
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-group">
                      <label for="cpf_cnpj">Praça de arrematação</label>
                      <select
                        style="text-transform: uppercase"
                        disabled
                        class="custom-select rounded-0"
                        id="arremate_praca"
                        v-model="arremate_praca"
                        @change="buscarLances()"
                      >
                        <option value="1">1º praça</option>
                        <option value="2">2º praça</option>
                        <option value="3">3º praça</option>
                        <option value="4">4º praça</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-sm-3">
                    <div class="form-group">
                      <label for="cpf_cnpj">Valor da arrematação</label>
                      <input
                        disabled
                        class="form-control"
                        v-model="valor_arrematacao"
                        pattern="[0-9][0-9.,]*[0-9]"
                        title="Valor válido"
                        @keyup="alterarValorArrematacao"
                        @blur="formatarValor"
                      />
                    </div>
                  </div>

                  <div class="col-sm-3" v-if="lotes">
                    <div class="form-group">
                      <label for="cpf_cnpj">Forma de pagamento</label>
                      <select :disabled="true" class="custom-select rounded-0 destaque" id="comitente" v-model="lotes.lote_ultimo_lance_parcelado">
                        <option :value="0">À VISTA</option>
                        <option :value="1">PARCELADO</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-sm-4" v-if="lance && lance.parcelado == 1">
                    <div class="form-group">
                      <label for="cpf_cnpj">% de entrada (lote)</label>
                      <input disabled class="form-control" type="number" placeholder="" v-model="perc_entrada" @keyup="calcularEntrada" />
                    </div>
                  </div>

                  <div class="col-sm-4" v-if="lance && lance.parcelado == 1">
                    <div class="form-group">
                      <label for="cpf_cnpj">Máximo de parcelas (lote)</label>
                      <input disabled class="form-control" type="number" placeholder="" v-model="arremate_numero_parcelas" />
                    </div>
                  </div>

                  <div class="col-sm-4" v-if="lance && lance.parcelado == 1">
                    <div class="form-group">
                      <label for="cpf_cnpj">Índice de correção (lote)</label>
                      <input class="form-control" placeholder="" v-model="indice_correcao" disabled />
                    </div>
                  </div>

                  <div class="col-sm-3" v-if="form_proposta && lotes.lote_ultimo_lance_parcelado == 1">
                    <div class="form-group">
                      <label for="cpf_cnpj">Valor proposta (proposta)</label>
                      <input disabled class="form-control" v-model="form_proposta.valor_proposta_formatado" />
                    </div>
                  </div>

                  <div class="col-sm-3" v-if="form_proposta && lotes.lote_ultimo_lance_parcelado == 1">
                    <div class="form-group">
                      <label for="cpf_cnpj">Valor entrada (proposta)</label>
                      <input disabled class="form-control" :value="toCurrency(form_proposta.valor_entrada)" />
                    </div>
                  </div>

                  <div class="col-sm-3" v-if="form_proposta && lotes.lote_ultimo_lance_parcelado == 1">
                    <div class="form-group">
                      <label for="cpf_cnpj">Núm. parcelas (proposta)</label>
                      <input class="form-control" v-model="num_parcelas" />
                    </div>
                  </div>

                  <div class="col-sm-3" v-if="form_proposta && lotes.lote_ultimo_lance_parcelado == 1">
                    <div class="form-group">
                      <label for="cpf_cnpj">Índice de correção (proposta)</label>
                      <input disabled class="form-control" v-model="form_proposta.indice" />
                    </div>
                  </div>

                  <div class="col-sm-3" v-if="form_proposta && lotes.lote_ultimo_lance_parcelado == 1">
                    <div class="form-group">
                      <label for="cpf_cnpj">% de entrada (proposta)</label>
                      <input class="form-control" v-model="pct_entrada" />
                    </div>
                  </div>

                  <div class="col-sm-3" v-if="form_proposta && lotes.lote_ultimo_lance_parcelado == 1">
                    <div class="form-group">
                      <label for="cpf_cnpj">Valor entrada (calculado)</label>
                      <input disabled class="form-control" :value="toCurrency(valor_entrada_calculado)" />
                    </div>
                  </div>

                  <div class="col-sm-3" v-if="form_proposta && lotes.lote_ultimo_lance_parcelado == 1">
                    <div class="form-group">
                      <label for="cpf_cnpj">Valor saldo (calculado)</label>
                      <input disabled class="form-control" :value="toCurrency(valor_saldo_calculado)" />
                    </div>
                  </div>

                  <div class="col-sm-3" v-if="form_proposta && lotes.lote_ultimo_lance_parcelado == 1">
                    <div class="form-group">
                      <label for="cpf_cnpj">Valor parcela (calculado)</label>
                      <input disabled class="form-control" :value="toCurrency(valor_parcela_calculado)" />
                    </div>
                  </div>

                  <div class="col-sm-2" v-if="lotes">
                    <div class="form-group">
                      <label for="cpf_cnpj">% Comissão</label>
                      <input disabled class="form-control" :value="toCurrency(lotes.lote_comissao)" />
                    </div>
                  </div>

                  <div class="col-sm-2" v-if="lotes">
                    <div class="form-group">
                      <label for="cpf_cnpj">Valor da comissão</label>
                      <input disabled class="form-control" :value="toCurrency(getValorComissao(lotes.lote_comissao))" />
                    </div>
                  </div>

                  <div class="col-sm-2" v-if="lotes">
                    <div class="form-group">
                      <label for="cpf_cnpj">% ICMS</label>
                      <input disabled class="form-control" :value="toCurrency(lotes.lote_icms)" />
                    </div>
                  </div>

                  <div class="col-sm-2" v-if="lotes">
                    <div class="form-group">
                      <label for="cpf_cnpj">Valor do ICMS</label>
                      <input disabled class="form-control" :value="toCurrency((lotes.lote_icms * lotes.lote_lance) / 100)" />
                    </div>
                  </div>

                  <div class="col-sm-2" v-if="lotes">
                    <div class="form-group">
                      <label for="cpf_cnpj">Taxa adm.</label>
                      <input disabled class="form-control" :value="toCurrency(leilao.leilao_taxa_administrativa)" />
                    </div>
                  </div>

                  <div class="col-sm-2" v-if="lotes">
                    <div class="form-group">
                      <label for="cpf_cnpj">Total com taxas</label>
                      <input disabled class="form-control" :value="getTotalTaxas()" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="cpf_cnpj">Data pagamento comissão</label>
                      <InputMask
                        id="leilao_data_1"
                        class="form-control"
                        v-model="data_pagamento_comissao"
                        placeholder="__/__/____"
                        mask="99/99/9999"
                        slotChar="__/__/____"
                      />
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="cpf_cnpj">Data pagamento guia judicial</label>
                      <InputMask
                        id="leilao_data_1"
                        class="form-control"
                        v-model="data_pagamento_guia"
                        placeholder="__/__/____"
                        mask="99/99/9999"
                        slotChar="__/__/____"
                      />
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="cpf_cnpj">Texto adicional 01</label>
                      <input class="form-control" v-model="texto_adicional_01" />
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="cpf_cnpj">Texto adicional 02</label>
                      <input class="form-control" v-model="texto_adicional_02" />
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="cpf_cnpj">Texto adicional 03</label>
                      <input class="form-control" v-model="texto_adicional_03" />
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="cpf_cnpj">Texto adicional 04</label>
                      <input class="form-control" v-model="texto_adicional_04" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card">
              <div class="card-header">
                <h3 class="card-title">Modelos de documentos</h3>
              </div>
              <div class="card-body">
                <div
                  class="col-12 col-sm-12 col-md-12"
                  v-if="
                    (modelos_auto_judicial && modelos_auto_judicial.length) ||
                    (modelos_auto_judicial_nao_coincidentes && modelos_auto_judicial_nao_coincidentes.length)
                  "
                >
                  <label>Autos de arrematação JUDICIAL</label>
                  <table class="table table-hover" style="position: relative">
                    <tbody>
                      <tr v-for="(modelo, index) in modelos_auto_judicial" :key="modelo">
                        <td>
                          <a
                            :href="getDocPath(modelo)"
                            target="_blank"
                            class="btn btn-primary"
                            type="submit"
                            style="margin-right: 5px; font-size: 7px"
                          >
                            <i class="fas fa-search" style="font-size: 12px"></i>
                          </a>
                          <button @click="saveDoc(modelo)" class="btn btn-info" type="submit" style="margin-right: 5px; font-size: 7px">
                            <i class="fas fa-plus" style="font-size: 12px"></i>
                          </button>
                          <span :class="modelo.class">#{{ modelo.id }} - {{ modelo.nome }}</span>

                          <!--
                      <span :class="modelo.class" style="text-transform: uppercase">
                        - {{ modelo.tipo_leilao == "extra" ? "Extrajudicial" : "Judicial" }} - {{ modelo.tipo_cadastro == "pf" ? "PF" : "PJ" }} -
                        {{ modelo.tipo_lote == "imovel" ? "Imóvel" : "Móvel" }} - {{ modelo.pagamento == "a_vista" ? "À VISTA" : "PARCELADO" }} -
                        {{ capitalizarPrimeiraLetra(modelo.estado_civil) }}
                      </span>
                      -->

                          <span v-if="modelo.json_matchs">
                            <span v-if="modelo.json_matchs.tipo_leilao" :class="modelo.json_matchs.tipo_leilao_class">
                              &nbsp;- {{ modelo.json_matchs.tipo_leilao }}
                            </span>
                            <span v-if="modelo.json_matchs.tipo_cadastro" :class="modelo.json_matchs.tipo_cadastro_class">
                              &nbsp;- {{ modelo.json_matchs.tipo_cadastro }}
                            </span>
                            <span v-if="modelo.json_matchs.tipo_lote" :class="modelo.json_matchs.tipo_lote_class">
                              &nbsp;- {{ modelo.json_matchs.tipo_lote }}
                            </span>
                            <span v-if="modelo.json_matchs.pagamento" :class="modelo.json_matchs.pagamento_class">
                              &nbsp;- {{ modelo.json_matchs.pagamento }}
                            </span>
                            <span v-if="modelo.json_matchs.estado_civil" :class="modelo.json_matchs.estado_civil_class">
                              &nbsp;- {{ modelo.json_matchs.estado_civil }}
                            </span>
                          </span>

                          <span :class="modelo.class" v-if="modelo.comitente_id" style="text-transform: uppercase; margin-left: 3px">
                            -{{ modelo.comitente }} - {{ modelo.cidade }}/{{ modelo.estado }}
                          </span>
                        </td>
                      </tr>
                      <button
                        @click="coincidentes_judicial = !coincidentes_judicial"
                        style="float: left; margin-top: -5px"
                        type="button"
                        class="btn btn-tool"
                        data-toggle="collapse"
                        href="#collapse0"
                      >
                        <i v-if="coincidentes_judicial" class="fas fa-minus" data-toggle="collapse" href="#collapse0"></i>
                        <i v-else class="fas fa-plus" data-toggle="collapse" href="#collapse0"></i>
                        Modelos não coincidentes
                      </button>
                    </tbody>
                  </table>
                  <div id="collapse0" class="collapse" data-parent="#accordion">
                    <table class="table table-hover" style="position: relative">
                      <tbody>
                        <tr v-for="(modelo, index) in modelos_auto_judicial_nao_coincidentes" :key="modelo">
                          <td>
                            <a
                              :href="getDocPath(modelo)"
                              target="_blank"
                              class="btn btn-primary"
                              type="submit"
                              style="margin-right: 5px; font-size: 7px"
                            >
                              <i class="fas fa-search" style="font-size: 12px"></i>
                            </a>
                            <button @click="saveDoc(modelo)" class="btn btn-info" type="submit" style="margin-right: 5px; font-size: 7px">
                              <i class="fas fa-plus" style="font-size: 12px"></i>
                            </button>
                            <span :class="modelo.class">#{{ modelo.id }} - {{ modelo.nome }}</span>

                            <span v-if="modelo.json_matchs">
                              <span v-if="modelo.json_matchs.tipo_leilao" :class="modelo.json_matchs.tipo_leilao_class">
                                &nbsp;- {{ modelo.json_matchs.tipo_leilao }}
                              </span>
                              <span v-if="modelo.json_matchs.tipo_cadastro" :class="modelo.json_matchs.tipo_cadastro_class">
                                &nbsp;- {{ modelo.json_matchs.tipo_cadastro }}
                              </span>
                              <span v-if="modelo.json_matchs.tipo_lote" :class="modelo.json_matchs.tipo_lote_class">
                                &nbsp;- {{ modelo.json_matchs.tipo_lote }}
                              </span>
                              <span v-if="modelo.json_matchs.pagamento" :class="modelo.json_matchs.pagamento_class">
                                &nbsp;- {{ modelo.json_matchs.pagamento }}
                              </span>
                              <span v-if="modelo.json_matchs.estado_civil" :class="modelo.json_matchs.estado_civil_class">
                                &nbsp;- {{ modelo.json_matchs.estado_civil }}
                              </span>
                            </span>

                            <span v-if="modelo.comitente_id" style="text-transform: uppercase; margin-left: 3px">
                              -{{ modelo.comitente }} - {{ modelo.cidade }}/{{ modelo.estado }}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div
                  class="col-12 col-sm-12 col-md-12"
                  v-if="
                    (modelos_auto_extra && modelos_auto_extra.length) ||
                    (modelos_auto_extra_nao_coincidentes && modelos_auto_extra_nao_coincidentes.length)
                  "
                >
                  <label>Autos de arrematação EXTRAJUDICIAL</label>
                  <table class="table table-hover" style="position: relative">
                    <tbody>
                      <tr v-for="(modelo, index) in modelos_auto_extra" :key="modelo">
                        <td>
                          <a
                            :href="getDocPath(modelo)"
                            target="_blank"
                            class="btn btn-primary"
                            type="submit"
                            style="margin-right: 5px; font-size: 7px"
                          >
                            <i class="fas fa-search" style="font-size: 12px"></i>
                          </a>
                          <button @click="saveDoc(modelo)" class="btn btn-info" type="submit" style="margin-right: 5px; font-size: 7px">
                            <i class="fas fa-plus" style="font-size: 12px"></i>
                          </button>
                          <span :class="modelo.class">#{{ modelo.id }} - {{ modelo.nome }}</span>

                          <!--
                      <span :class="modelo.class" style="text-transform: uppercase">
                        - {{ modelo.tipo_leilao == "extra" ? "Extrajudicial" : "Judicial" }} - {{ modelo.tipo_cadastro == "pf" ? "PF" : "PJ" }} -
                        {{ modelo.tipo_lote == "imovel" ? "Imóvel" : "Móvel" }} - {{ modelo.pagamento == "a_vista" ? "À VISTA" : "PARCELADO" }} -
                        {{ capitalizarPrimeiraLetra(modelo.estado_civil) }}
                      </span>
                      -->

                          <span v-if="modelo.json_matchs">
                            <span v-if="modelo.json_matchs.tipo_leilao" :class="modelo.json_matchs.tipo_leilao_class">
                              &nbsp;- {{ modelo.json_matchs.tipo_leilao }}
                            </span>
                            <span v-if="modelo.json_matchs.tipo_cadastro" :class="modelo.json_matchs.tipo_cadastro_class">
                              &nbsp;- {{ modelo.json_matchs.tipo_cadastro }}
                            </span>
                            <span v-if="modelo.json_matchs.tipo_lote" :class="modelo.json_matchs.tipo_lote_class">
                              &nbsp;- {{ modelo.json_matchs.tipo_lote }}
                            </span>
                            <span v-if="modelo.json_matchs.pagamento" :class="modelo.json_matchs.pagamento_class">
                              &nbsp;- {{ modelo.json_matchs.pagamento }}
                            </span>
                            <span v-if="modelo.json_matchs.estado_civil" :class="modelo.json_matchs.estado_civil_class">
                              &nbsp;- {{ modelo.json_matchs.estado_civil }}
                            </span>
                          </span>

                          <span :class="modelo.class" v-if="modelo.comitente_id" style="text-transform: uppercase; margin-left: 3px">
                            -{{ modelo.comitente }} - {{ modelo.cidade }}/{{ modelo.estado }}
                          </span>
                        </td>
                      </tr>
                      <button
                        @click="coincidentes_extra = !coincidentes_extra"
                        style="float: left; margin-top: -5px"
                        type="button"
                        class="btn btn-tool"
                        data-toggle="collapse"
                        href="#collapse1"
                      >
                        <i v-if="coincidentes_extra" class="fas fa-minus" data-toggle="collapse" href="#collapse1"></i>
                        <i v-else class="fas fa-plus" data-toggle="collapse" href="#collapse1"></i>
                        Modelos não coincidentes
                      </button>
                    </tbody>
                  </table>
                  <div id="collapse1" class="collapse" data-parent="#accordion">
                    <table class="table table-hover" style="position: relative">
                      <tbody>
                        <tr v-for="(modelo, index) in modelos_auto_extra_nao_coincidentes" :key="modelo">
                          <td>
                            <a
                              :href="getDocPath(modelo)"
                              target="_blank"
                              class="btn btn-primary"
                              type="submit"
                              style="margin-right: 5px; font-size: 7px"
                            >
                              <i class="fas fa-search" style="font-size: 12px"></i>
                            </a>
                            <button @click="saveDoc(modelo)" class="btn btn-info" type="submit" style="margin-right: 5px; font-size: 7px">
                              <i class="fas fa-plus" style="font-size: 12px"></i>
                            </button>
                            <span :class="modelo.class">#{{ modelo.id }} - {{ modelo.nome }}</span>

                            <span v-if="modelo.json_matchs">
                              <span v-if="modelo.json_matchs.tipo_leilao" :class="modelo.json_matchs.tipo_leilao_class">
                                &nbsp;- {{ modelo.json_matchs.tipo_leilao }}
                              </span>
                              <span v-if="modelo.json_matchs.tipo_cadastro" :class="modelo.json_matchs.tipo_cadastro_class">
                                &nbsp;- {{ modelo.json_matchs.tipo_cadastro }}
                              </span>
                              <span v-if="modelo.json_matchs.tipo_lote" :class="modelo.json_matchs.tipo_lote_class">
                                &nbsp;- {{ modelo.json_matchs.tipo_lote }}
                              </span>
                              <span v-if="modelo.json_matchs.pagamento" :class="modelo.json_matchs.pagamento_class">
                                &nbsp;- {{ modelo.json_matchs.pagamento }}
                              </span>
                              <span v-if="modelo.json_matchs.estado_civil" :class="modelo.json_matchs.estado_civil_class">
                                &nbsp;- {{ modelo.json_matchs.estado_civil }}
                              </span>
                            </span>

                            <span v-if="modelo.comitente_id" style="text-transform: uppercase; margin-left: 3px">
                              -{{ modelo.comitente }} - {{ modelo.cidade }}/{{ modelo.estado }}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div
                  class="col-12 col-sm-12 col-md-12"
                  v-if="
                    (modelos_auto_negativos && modelos_auto_negativos.length) ||
                    (modelos_auto_negativos_nao_coincidentes && modelos_auto_negativos_nao_coincidentes.length)
                  "
                >
                  <label>Autos negativos</label>
                  <table class="table table-hover" style="position: relative">
                    <tbody>
                      <tr v-for="(modelo, index) in modelos_auto_negativos" :key="modelo">
                        <td>
                          <a
                            :href="getDocPath(modelo)"
                            target="_blank"
                            class="btn btn-primary"
                            type="submit"
                            style="margin-right: 5px; font-size: 7px"
                          >
                            <i class="fas fa-search" style="font-size: 12px"></i>
                          </a>
                          <button @click="saveDoc(modelo)" class="btn btn-info" type="submit" style="margin-right: 5px; font-size: 7px">
                            <i class="fas fa-plus" style="font-size: 12px"></i>
                          </button>
                          <span :class="modelo.class">#{{ modelo.id }} - {{ modelo.nome }}</span>

                          <!--
                      <span :class="modelo.class" style="text-transform: uppercase">
                        - {{ modelo.tipo_leilao == "extra" ? "Extrajudicial" : "Judicial" }} - {{ modelo.tipo_cadastro == "pf" ? "PF" : "PJ" }} -
                        {{ modelo.tipo_lote == "imovel" ? "Imóvel" : "Móvel" }} - {{ modelo.pagamento == "a_vista" ? "À VISTA" : "PARCELADO" }} -
                        {{ capitalizarPrimeiraLetra(modelo.estado_civil) }}
                      </span>
                      -->

                          <span v-if="modelo.json_matchs">
                            <span v-if="modelo.json_matchs.tipo_leilao" :class="modelo.json_matchs.tipo_leilao_class">
                              &nbsp;- {{ modelo.json_matchs.tipo_leilao }}
                            </span>
                            <span v-if="modelo.json_matchs.tipo_cadastro" :class="modelo.json_matchs.tipo_cadastro_class">
                              &nbsp;- {{ modelo.json_matchs.tipo_cadastro }}
                            </span>
                            <span v-if="modelo.json_matchs.tipo_lote" :class="modelo.json_matchs.tipo_lote_class">
                              &nbsp;- {{ modelo.json_matchs.tipo_lote }}
                            </span>
                            <span v-if="modelo.json_matchs.pagamento" :class="modelo.json_matchs.pagamento_class">
                              &nbsp;- {{ modelo.json_matchs.pagamento }}
                            </span>
                            <span v-if="modelo.json_matchs.estado_civil" :class="modelo.json_matchs.estado_civil_class">
                              &nbsp;- {{ modelo.json_matchs.estado_civil }}
                            </span>
                          </span>

                          <span :class="modelo.class" v-if="modelo.comitente_id" style="text-transform: uppercase; margin-left: 3px">
                            -{{ modelo.comitente }} - {{ modelo.cidade }}/{{ modelo.estado }}
                          </span>
                        </td>
                      </tr>

                      <button
                        @click="coincidentes_negativo = !coincidentes_negativo"
                        style="float: left; margin-top: -5px"
                        type="button"
                        class="btn btn-tool"
                        data-toggle="collapse"
                        href="#collapse2"
                      >
                        <i v-if="coincidentes_negativo" class="fas fa-minus" data-toggle="collapse" href="#collapse2"></i>
                        <i v-else class="fas fa-plus" data-toggle="collapse" href="#collapse2"></i>
                        Modelos não coincidentes
                      </button>
                    </tbody>
                  </table>
                  <div id="collapse2" class="collapse" data-parent="#accordion">
                    <table class="table table-hover" style="position: relative">
                      <tbody>
                        <tr v-for="(modelo, index) in modelos_auto_negativos_nao_coincidentes" :key="modelo">
                          <td>
                            <a
                              :href="getDocPath(modelo)"
                              target="_blank"
                              class="btn btn-primary"
                              type="submit"
                              style="margin-right: 5px; font-size: 7px"
                            >
                              <i class="fas fa-search" style="font-size: 12px"></i>
                            </a>
                            <button @click="saveDoc(modelo)" class="btn btn-info" type="submit" style="margin-right: 5px; font-size: 7px">
                              <i class="fas fa-plus" style="font-size: 12px"></i>
                            </button>
                            <span :class="modelo.class">#{{ modelo.id }} - {{ modelo.nome }}</span>

                            <span v-if="modelo.json_matchs">
                              <span v-if="modelo.json_matchs.tipo_leilao" :class="modelo.json_matchs.tipo_leilao_class">
                                &nbsp;- {{ modelo.json_matchs.tipo_leilao }}
                              </span>
                              <span v-if="modelo.json_matchs.tipo_cadastro" :class="modelo.json_matchs.tipo_cadastro_class">
                                &nbsp;- {{ modelo.json_matchs.tipo_cadastro }}
                              </span>
                              <span v-if="modelo.json_matchs.tipo_lote" :class="modelo.json_matchs.tipo_lote_class">
                                &nbsp;- {{ modelo.json_matchs.tipo_lote }}
                              </span>
                              <span v-if="modelo.json_matchs.pagamento" :class="modelo.json_matchs.pagamento_class">
                                &nbsp;- {{ modelo.json_matchs.pagamento }}
                              </span>
                              <span v-if="modelo.json_matchs.estado_civil" :class="modelo.json_matchs.estado_civil_class">
                                &nbsp;- {{ modelo.json_matchs.estado_civil }}
                              </span>
                            </span>

                            <span v-if="modelo.comitente_id" style="text-transform: uppercase; margin-left: 3px">
                              -{{ modelo.comitente }} - {{ modelo.cidade }}/{{ modelo.estado }}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div
                  class="col-12 col-sm-12 col-md-12"
                  v-if="
                    (modelos_nota_venda && modelos_nota_venda.length) ||
                    (modelos_nota_venda_nao_coincidentes && modelos_nota_venda_nao_coincidentes.length)
                  "
                >
                  <label>Notas de venda</label>
                  <table class="table table-hover" style="position: relative">
                    <tbody>
                      <tr v-for="(modelo, index) in modelos_nota_venda" :key="modelo">
                        <td>
                          <a
                            :href="getDocPath(modelo)"
                            target="_blank"
                            class="btn btn-primary"
                            type="submit"
                            style="margin-right: 5px; font-size: 7px"
                          >
                            <i class="fas fa-search" style="font-size: 12px"></i>
                          </a>
                          <button @click="saveDoc(modelo, true)" class="btn btn-info" type="submit" style="margin-right: 5px; font-size: 7px">
                            <i class="fas fa-plus" style="font-size: 12px"></i>
                          </button>
                          <span :class="modelo.class">#{{ modelo.id }} - {{ modelo.nome }}</span>

                          <!--
                      <span :class="modelo.class" style="text-transform: uppercase">
                        - {{ modelo.tipo_leilao == "extra" ? "Extrajudicial" : "Judicial" }} - {{ modelo.tipo_cadastro == "pf" ? "PF" : "PJ" }} -
                        {{ modelo.tipo_lote == "imovel" ? "Imóvel" : "Móvel" }} - {{ modelo.pagamento == "a_vista" ? "À VISTA" : "PARCELADO" }} -
                        {{ capitalizarPrimeiraLetra(modelo.estado_civil) }}
                      </span>
                      -->

                          <span v-if="modelo.json_matchs">
                            <span v-if="modelo.json_matchs.tipo_leilao" :class="modelo.json_matchs.tipo_leilao_class">
                              &nbsp;- {{ modelo.json_matchs.tipo_leilao }}
                            </span>
                            <span v-if="modelo.json_matchs.tipo_cadastro" :class="modelo.json_matchs.tipo_cadastro_class">
                              &nbsp;- {{ modelo.json_matchs.tipo_cadastro }}
                            </span>
                            <span v-if="modelo.json_matchs.tipo_lote" :class="modelo.json_matchs.tipo_lote_class">
                              &nbsp;- {{ modelo.json_matchs.tipo_lote }}
                            </span>
                            <span v-if="modelo.json_matchs.pagamento" :class="modelo.json_matchs.pagamento_class">
                              &nbsp;- {{ modelo.json_matchs.pagamento }}
                            </span>
                            <span v-if="modelo.json_matchs.estado_civil" :class="modelo.json_matchs.estado_civil_class">
                              &nbsp;- {{ modelo.json_matchs.estado_civil }}
                            </span>
                          </span>

                          <span :class="modelo.class" v-if="modelo.comitente_id" style="text-transform: uppercase; margin-left: 3px">
                            - {{ modelo.comitente }} - {{ modelo.cidade }}/{{ modelo.estado }}
                          </span>
                        </td>
                      </tr>
                      <button
                        @click="coincidentes_venda = !coincidentes_venda"
                        style="float: left; margin-top: -5px"
                        type="button"
                        class="btn btn-tool"
                        data-toggle="collapse"
                        href="#collapse3"
                      >
                        <i v-if="coincidentes_venda" class="fas fa-minus" data-toggle="collapse" href="#collapse3"></i>
                        <i v-else class="fas fa-plus" data-toggle="collapse" href="#collapse3"></i>
                        Modelos não coincidentes
                      </button>
                    </tbody>
                  </table>
                  <div id="collapse3" class="collapse" data-parent="#accordion">
                    <table class="table table-hover" style="position: relative">
                      <tbody>
                        <tr v-for="(modelo, index) in modelos_nota_venda_nao_coincidentes" :key="modelo">
                          <td>
                            <a
                              :href="getDocPath(modelo)"
                              target="_blank"
                              class="btn btn-primary"
                              type="submit"
                              style="margin-right: 5px; font-size: 7px"
                            >
                              <i class="fas fa-search" style="font-size: 12px"></i>
                            </a>
                            <button @click="saveDoc(modelo)" class="btn btn-info" type="submit" style="margin-right: 5px; font-size: 7px">
                              <i class="fas fa-plus" style="font-size: 12px"></i>
                            </button>
                            <span :class="modelo.class">#{{ modelo.id }} - {{ modelo.nome }}</span>

                            <span v-if="modelo.json_matchs">
                              <span v-if="modelo.json_matchs.tipo_leilao" :class="modelo.json_matchs.tipo_leilao_class">
                                &nbsp;- {{ modelo.json_matchs.tipo_leilao }}
                              </span>
                              <span v-if="modelo.json_matchs.tipo_cadastro" :class="modelo.json_matchs.tipo_cadastro_class">
                                &nbsp;- {{ modelo.json_matchs.tipo_cadastro }}
                              </span>
                              <span v-if="modelo.json_matchs.tipo_lote" :class="modelo.json_matchs.tipo_lote_class">
                                &nbsp;- {{ modelo.json_matchs.tipo_lote }}
                              </span>
                              <span v-if="modelo.json_matchs.pagamento" :class="modelo.json_matchs.pagamento_class">
                                &nbsp;- {{ modelo.json_matchs.pagamento }}
                              </span>
                              <span v-if="modelo.json_matchs.estado_civil" :class="modelo.json_matchs.estado_civil_class">
                                &nbsp;- {{ modelo.json_matchs.estado_civil }}
                              </span>
                            </span>

                            <span v-if="modelo.comitente_id" style="text-transform: uppercase; margin-left: 3px">
                              - {{ modelo.comitente }} - {{ modelo.cidade }}/{{ modelo.estado }}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <br />
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">Documenos gerados</h3>
              </div>
              <div class="card-body">
                <div class="col-12 col-sm-12 col-md-12" v-if="saved_docs && saved_docs.length">
                  <label>Documentos gerados</label>
                  <table class="table table-hover" style="position: relative">
                    <tbody>
                      <tr v-for="(modelo, index) in saved_docs" :key="modelo">
                        <td>
                          <a
                            :href="getDocPath(modelo)"
                            target="_blank"
                            class="btn btn-primary"
                            type="submit"
                            style="margin-right: 5px; font-size: 7px"
                          >
                            <i class="fas fa-search" style="font-size: 12px"></i>
                          </a>
                          <a
                            @click="deletarDoc(modelo)"
                            target="_blank"
                            class="btn btn-danger"
                            type="submit"
                            style="margin-right: 5px; font-size: 7px"
                          >
                            <i class="fas fa-trash" style="font-size: 12px"></i>
                          </a>
                          <span :class="modelo.class">#{{ modelo.id }} - {{ modelo.nome }}</span>
                          - {{ formatDateTime(modelo.created_at) }}
                          <span v-if="modelo.comitente_id" style="text-transform: uppercase; margin-left: 3px">
                            -{{ modelo.comitente }} - {{ modelo.cidade }}/{{ modelo.estado }}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12">
              <button style="margin-left: 5px" data-dismiss="modal" aria-hidden="true" @click="cancelModal" class="btn btn-danger">Fechar</button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import auxFormatacao from "../../controller/auxFormatacao.js";
import sweetAlert from "../../controller/sweetAlert.js";
import currencyController from "../../controller/currencyController.js";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import Loading from "vue-loading-overlay";
//import moment, { relativeTimeThreshold } from "moment";
import moment from "moment-timezone";
import "vue-loading-overlay/dist/vue-loading.css";
import InputMask from "primevue/inputmask";
import numero from "numero-por-extenso";
import "moment/locale/pt-br";

import ContextMenu from "primevue/contextmenu";

export default {
  props: ["lote_id", "setGerarDocumento", "leilao"],

  mixins: [sweetAlert, Swal, AuxController, currencyController, auxFormatacao],

  components: { Loading, ContextMenu, InputMask },

  data() {
    return {
      isLoading: false,
      modelos_docs: [],
      modelos_auto_extra: [],
      modelos_auto_extra_nao_coincidentes: [],
      modelos_auto_judicial: [],
      modelos_auto_judicial_nao_coincidentes: [],
      modelos_auto_negativos: [],
      modelos_auto_negativos_nao_coincidentes: [],
      modelos_nota_venda: [],
      modelos_nota_venda_nao_coincidentes: [],
      modelos_processo: [],
      modelos_processo_nao_coincidentes: [],
      saved_docs: [],
      data_pagamento_comissao: "",
      data_pagamento_guia: "",
      arremate_praca: "",
      valor_arrematacao_number: "",
      valor_arrematacao: "",
      lance: "",
      valor_entrada: "10",
      perc_entrada: "",
      arremate_numero_parcelas: "",
      indice_correcao: "TJ/PR (INPC/IGPDI)",
      processo_estado_sigla: "Olá, processo_estado_sigla!",
      user_profile: "",
      variaveis_documentos: [],
      tags_nao_encontradas: [],
      lances: [],
      processo: "",
      modelo_selecionado: "",
      total_lances_indice: 0,
      dados_json_para_docx: {},
      texto_adicional_01: "",
      texto_adicional_02: "",
      texto_adicional_03: "",
      texto_adicional_04: "",
      comitente: "",
      comitentes: [],
      comitente_id: "",
      lotes: "",
      valor_comissao: "",
      valor_icms: "",
      form_proposta: "",
      valor_entrada_calculado: "",
      valor_saldo_calculado: "",
      valor_parcela_calculado: "",
      processos: "",
      segundo_lance: "",
      total_com_taxas: "",
      num_parcelas: 0,
      pct_entrada: 0,
      nota_venda: false,
      coincidentes_extra: false,
      coincidentes_judicial: false,
      coincidentes_negativo: false,
      coincidentes_venda: false,
      segundo_lance_valor: "",
    };
  },

  mounted() {
    console.log("Gerar documento");

    //O NOME ESTÁ NO PLURAL PRA FAZER REFERENCIA A TABELA 'LOTES'
    this.buscarLote(() => {
      this.buscarProposta();
      this.buscarLances();

      this.valor_arrematacao = this.toCurrency(this.lotes.lote_lance);
      this.valor_icms = (this.lotes.lote_icms * this.lotes.lote_lance) / 100;
      this.valor_comissao = this.getValorComissao();

      this.perc_entrada = this.lotes.lote_pct_entrada;
      this.arremate_numero_parcelas = this.lotes.lote_max_parcelas;

      this.data_pagamento_comissao = moment(new Date()).format("DD/MM/YYYY");

      let amanha = new Date();
      amanha.setDate(amanha.getDate() + 1);

      this.data_pagamento_guia = moment(amanha).format("DD/MM/YYYY");

      //let mensagemFinal = "Olá ${lote_titulo}, <tudo_bem> com vc? ${processo_estado_sigla}\n\n${cadastro_profissao_TTT}\n\n${cadastro_estado_sigla}";
      //this.gerarJsonDados(mensagemFinal);

      this.arremate_praca = this.lotes.lote_lance_praca;

      this.comitente_id = this.leilao.comitente_id;
    });

    //AGORA SOMENTE EM MODELOS
    //this.buscarModelos

    console.log(this.formatarCep("59114000"));
    console.log(1000 / 3);
    console.log(this.formatar02CasaDecimal(1000 / 3));
    console.log(numero.porExtenso(this.formatar02CasaDecimal(1000 / 3), numero.estilo.monetario));
    console.log(this.formatar02CasaDecimal("94229.85412"));
    console.log(this.toNumber("94229,85412"));
    console.log(numero.porExtenso(this.toNumber("94229.85412"), numero.estilo.monetario));
    console.log(numero.porExtenso(this.toNumber("94229,85412"), numero.estilo.monetario));
    console.log(numero.porExtenso(this.formatar02CasaDecimal(Number(this.toNumber(94229.85)), numero.estilo.monetario)));
    console.log(numero.porExtenso(94229.85, numero.estilo.monetario));

    this.buscarVariaveisDocumentos();
    this.buscarComitentes();

    console.log("MINHA HORA " + this.getOnlyTime("2024-10-10 11:13:15"));
    console.log("Meu telefone " + this.formatarTelefone("84123412"));
    console.log(this.getOnlyMonth("2022-10-19 10:45:00"));
    console.log(this.getOnlyMonthExtenso("2022-10-19 10:45:00"));
    console.log(this.getOnlyDay("2024-07-01"));
    console.log(this.getOnlyDayExtenso("2024-07-01"));
    console.log(this.getOnlyYear("2024-07-01"));
    console.log(this.getOnlyYearExtenso("2024-07-01"));
    console.log(moment(new Date("2024-07-01")).locale("pt-br").format("D [de] MMMM [de] YYYY"));
    console.log(moment(new Date("2024-07-01")).locale("pt-br").format("MMMM"));
    console.log(moment(new Date("2024-07-01")).locale("pt-br").format("MM"));

    /*
    console.log(numero.porExtenso(1.5, numero.estilo.monetario));
    console.log(numero.porExtenso(10.5, numero.estilo.monetario));
    console.log(numero.porExtenso(25, numero.estilo.monetario));
    console.log(numero.porExtenso(1000, numero.estilo.monetario));
    console.log(numero.porExtenso(10.5));
    console.log(numero.porExtenso(10.5));
    console.log(numero.porExtenso(25));
    console.log(numero.porExtenso(225));
    console.log(numero.porExtenso(100500));
    console.log(numero.porExtenso(1000201));
    */
  },

  methods: {
    capitalizarPrimeiraLetra(str) {
      if (!str || str.length === 0) return str;
      return str.charAt(0).toUpperCase() + str.slice(1);
    },

    getTotalTaxas() {
      let icms = this.formatar02CasaDecimal((this.lotes.lote_icms * this.lotes.lote_lance) / 100);
      let comissao = this.formatar02CasaDecimal(this.getValorComissao());

      console.log("TOTAL TAXAS");
      console.log(icms);
      console.log(comissao);
      console.log(Number(icms) + Number(comissao));

      this.total_com_taxas = Number(icms) + Number(comissao) + Number(this.leilao.leilao_taxa_administrativa) + this.lotes.lote_lance;

      return this.toCurrency(this.total_com_taxas);
    },

    getValorComissao() {
      return (this.lotes.lote_lance * this.lotes.lote_comissao) / 100;
    },

    buscarComitentes() {
      let data = {
        inicio: 0,
        tamanho: 100000,
        alfabetico: true,
      };

      axios
        .post(`/admin/comitente/search_all_join`, data)
        .then((response) => {
          this.comitentes = response.data.comitentes;

          let indice_comitente = this.comitentes.findIndex((element) => element["id"] == this.comitente_id);

          if (indice_comitente >= 0) {
            this.comitente = this.comitentes[indice_comitente];
          }

          console.log("Gerar documento");
          console.log(this.comitentes);
          console.log(this.comitente_id);
          console.log(this.comitente);

          this.processos = this.lotes.processo;
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    getPrefix(lance) {
      let prefix = "";
      let user_profile = lance.user_profile;

      if (user_profile) {
        //console.log("Com profile");
        //console.log(user_profile);

        if (user_profile.cadastro_tipo == "pf") {
          prefix = "PF";
        } else if (user_profile.cadastro_tipo == "pj") {
          prefix = "PJ";
        }

        if (user_profile.estado_civil == "casado" || user_profile.estado_civil == "solteiro_com_uniao_estavel") {
          prefix = prefix + "C ";
        } else {
          prefix = prefix + " ";
        }
      }

      console.log("Prefix");
      console.log(prefix);

      return prefix + lance.apelido;
    },

    alterarValorArrematacao() {
      this.valor_arrematacao_number = Number(this.toNumber(this.valor_arrematacao));
    },

    formatarValor() {
      this.valor_arrematacao = this.toCurrency(this.valor_arrematacao_number);
    },

    changeValor() {
      this.user_profile = this.lance.user_cadastros;

      console.log("User profile no lance");
      console.log(this.user_profile);
      console.log(this.lance);

      //this.alterarValorArrematacao();
      //this.formatarValor();
      this.calcularEntrada();
    },

    calcularEntrada() {
      this.valor_entrada = this.toCurrency((this.perc_entrada * this.valor_arrematacao_number) / 100);

      console.log("VALOR ENTRADA");
      console.log(this.valor_entrada);
    },

    replaceAll(string, search, replace) {
      return string.split(search).join(replace);
    },

    loadFile(url, callback) {
      PizZipUtils.getBinaryContent(url, callback);
    },

    gerarJsonDados(texto) {
      let tags = this.localizar_tags(texto);

      console.log("Tags localizadas");
      console.log(tags);

      this.dados_json_para_docx = {};
      this.tags_nao_encontradas = [];

      for (let i = 0; i < tags.length; i++) {
        let tag_completa = tags[i];
        let tag = tags[i];

        console.log("\n\n\nBuscando tag " + tag);

        let uppercase = false;
        let lowercase = true;

        //ANTIGO CÓDIGO TTT - EM VALIDAÇÃO

        /*
        if (tag.includes("TTT")) {
          console.log("POSSUI TTT");

          let split = tag.split("_");

          tag = this.replaceAll(tag, "_" + split[split.length - 1], "");

          console.log("Depois de formatado");
          console.log(tag);

          uppercase = true;
        }

        if (tag.includes("TtT")) {
          console.log("POSSUI TtT");

          let split = tag.split("_");

          tag = this.replaceAll(tag, "_" + split[split.length - 1], "");

          console.log("Depois de formatado");
          console.log(tag);

          uppercase = true;
        }

        if (tag.includes("ttt")) {
          console.log("POSSUI ttt");

          let split = tag.split("_");

          tag = this.replaceAll(tag, "_" + split[split.length - 1], "");

          console.log("Depois de formatado");
          console.log(tag);

          lowercase = true;
        }
        */

        let indice = this.variaveis_documentos.findIndex((element) => element["variavel_doc"] == "${" + tag + "}");

        if (indice >= 0) {
          console.log("\nEncontrou o campo");
          console.log(tags[i]);

          let extenso = false;

          if (tag.includes("_ext_") || (tag.length >= 4 && tag.slice(-4) == "_ext")) {
            extenso = true;
          }

          if (tag.includes("_ext_") || (tag.length >= 4 && tag.slice(-4) == "_ext")) {
            extenso = true;
          }

          let nome_tabela = this.variaveis_documentos[indice].tabela;
          let nome_campo = this.variaveis_documentos[indice].campo;
          let join = this.variaveis_documentos[indice].relacionamento;
          let formatacao = this.variaveis_documentos[indice].formatacao;

          console.log("Buscando " + nome_campo);

          console.log("Tabela");
          console.log(nome_tabela);
          console.log(this[nome_tabela]);

          //BUSCANDO VARIÁVEL NO CONTEXTO
          if (nome_tabela && this[nome_tabela]) {
            console.log("Encontrou a tabela");
            let value = "";

            console.log("Campo - " + tags[i]);

            //VERIFICANDO JOIN
            if (join) {
              console.log("Verificando JOIN");

              if (this[nome_tabela][join] && this[nome_tabela][join][nome_campo]) {
                console.log("Entrou no IF join");
                console.log(this[nome_tabela][join]);
                console.log("Valor - " + this[nome_tabela][join][nome_campo]);

                this.addToJsonDados(tag_completa, this[nome_tabela][join][nome_campo], uppercase, formatacao, extenso, lowercase, nome_campo);
              }
            } else if (this[nome_tabela][nome_campo]) {
              console.log("Valor - " + this[nome_tabela][nome_campo]);

              this.addToJsonDados(tag_completa, this[nome_tabela][nome_campo], uppercase, formatacao, extenso, lowercase, nome_campo);
            }
          } else if (this[nome_campo]) {
            console.log("Encontrou a variavel");

            console.log("Campo - " + tags[i]);
            console.log("Valor - " + this[nome_campo]);

            this.addToJsonDados(tag_completa, this[nome_campo], uppercase, formatacao, extenso, lowercase, nome_campo);
          } else {
            console.log("campo não encontrado " + tags[i]);
            this.tags_nao_encontradas.push(tags[i]);
          }
        } else {
          console.log("NÃO ENCONTROU NO BANCO" + tags[i]);
        }
      }

      console.log("Dados final");
      console.log(this.dados_json_para_docx);

      return this.dados_json_para_docx;
    },

    numeroOrdinalPorExtensoGenero(n, genero = "masculino") {
      const unidadesMasculino = [
        "",
        "primeiro",
        "segundo",
        "terceiro",
        "quarto",
        "quinto",
        "sexto",
        "sétimo",
        "oitavo",
        "nono",
        "décimo",
        "décimo primeiro",
        "décimo segundo",
        "décimo terceiro",
        "décimo quarto",
        "décimo quinto",
        "décimo sexto",
        "décimo sétimo",
        "décimo oitavo",
        "décimo nono",
      ];

      const unidadesFeminino = [
        "",
        "primeira",
        "segunda",
        "terceira",
        "quarta",
        "quinta",
        "sexta",
        "sétima",
        "oitava",
        "nona",
        "décima",
        "décima primeira",
        "décima segunda",
        "décima terceira",
        "décima quarta",
        "décima quinta",
        "décima sexta",
        "décima sétima",
        "décima oitava",
        "décima nona",
      ];

      const dezenasMasculino = [
        "",
        "",
        "vigésimo",
        "trigésimo",
        "quadragésimo",
        " quinquagésimo",
        "sexagésimo",
        "septuagésimo",
        "octogésimo",
        "nonagésimo",
      ];

      const dezenasFeminino = [
        "",
        "",
        "vigésima",
        "vigésima",
        "quadragésima",
        " quinquagésima",
        "sexagésima",
        "septuagésima",
        "octogésima",
        "nonagésima",
      ];

      const centenasMasculino = [
        "",
        "centésimo",
        "ducentésimo",
        "trecentésimo",
        "quadringentésimo",
        "quingentésimo",
        "sexcentésimo",
        "septingentésimo",
        "octingentésimo",
        "noningentésimo",
      ];

      const centenasFeminino = [
        "",
        "centésima",
        "ducentésima",
        "trecentésima",
        "quadringentésima",
        "quingentésima",
        "sexcentésima",
        "septingentésima",
        "octingentésima",
        "noningentésima",
      ];

      const unidades = genero === "masculino" ? unidadesMasculino : unidadesFeminino;
      const dezenas = genero === "masculino" ? dezenasMasculino : dezenasFeminino;
      const centenas = genero === "masculino" ? centenasMasculino : centenasFeminino;

      if (n === 0) return "zero";

      let extenso = "";

      // Lidar com as centenas
      const c = Math.floor(n / 100);
      n = n % 100;
      if (c > 0) {
        extenso += centenas[c];
        if (n > 0) extenso += " e ";
      }

      // Lidar com as dezenas
      const d = Math.floor(n / 10);
      const u = n % 10; // Unidades restantes
      if (d > 1) {
        extenso += dezenas[d];
        if (u > 0) {
          extenso += " e " + unidades[u];
        }
      } else if (d === 1) {
        extenso += unidades[10 + u];
      } else if (u > 0) {
        extenso += unidades[u];
      }

      return extenso.trim();
    },

    addToJsonDados(nome_campo, valor, uppercase, formatacao, extenso, lowercase, nome_variavel) {
      //FORMATANDO CAMPO COM HTML
      if (typeof valor == "string" && valor.includes("</")) {
        var div = document.createElement("div");
        div.innerHTML = valor;
        valor = div.textContent || div.innerText || "";
      } else if (formatacao == "data") {
        valor = this.formatOnlyDate(valor);
      }

      let data = false;

      if (nome_campo.includes("_aaaa_") || (nome_campo.length >= 5 && nome_campo.slice(-5) == "_aaaa")) {
        console.log("FORMATANDO ANO");
        console.log(valor);

        if (extenso) {
          valor = this.getOnlyYearExtenso(valor);
        } else {
          valor = this.getOnlyYear(valor);
        }

        console.log("VALOR DATA");
        console.log(valor);

        data = true;
      }

      if (nome_campo.includes("_mm_") || (nome_campo.length >= 3 && nome_campo.slice(-3) == "_mm")) {
        console.log("FORMATANDO MES");
        console.log(valor);
        if (extenso) {
          valor = this.getOnlyMonthExtenso(valor);
        } else {
          valor = this.getOnlyMonth(valor);
        }

        console.log("VALOR DATA");
        console.log(valor);

        data = true;
      }

      if (nome_campo.includes("_dd_") || (nome_campo.length >= 3 && nome_campo.slice(-3) == "_dd")) {
        console.log("FORMATANDO DIA");
        console.log(valor);

        if (extenso) {
          valor = this.getOnlyDayExtenso(valor);
        } else {
          valor = this.getOnlyDay(valor);
        }

        console.log("VALOR DATA");
        console.log(valor);

        data = true;
      }

      if (nome_campo.length >= 5 && nome_campo.slice(-5) == "_hhmi") {
        console.log("FORMATANDO HHMI");
        console.log(valor);

        valor = this.getOnlyTime(valor);

        console.log("VALOR HHMI");
        console.log(valor);

        data = true;
      }

      if (formatacao == "telefone") {
        valor = this.formatarTelefone(valor);
      }

      if (formatacao == "cpf" && valor != " ") {
        valor = this.formatarCPF(valor);
      }

      if (!extenso && formatacao == "moeda") {
        if (nome_variavel == "segundo_lance_valor") {
          if (valor != "NÃO HOUVE") {
            valor = "R$ " + this.toCurrency(valor);
          }
        } else {
          valor = this.toCurrency(valor);
        }
      }

      if (!extenso && formatacao == "regime casamento") {
        if (valor == "cpb") {
          valor = "Comunhão parcial de bens";
        }

        if (valor == "cub") {
          valor = "Comunhão universal de bens";
        }

        if (valor == "outros") {
          valor = "Outros";
        }

        if (valor == "pfa") {
          valor = "Participação final nos aquestos";
        }

        if (valor == "seb") {
          valor = "Separação de bens";
        }
      }

      if (!extenso && formatacao == "cnpj") {
        valor = this.formatarCNPJ(valor);
      }

      if (!extenso && formatacao == "cep") {
        valor = this.formatarCep(valor);
      }

      if (extenso && !data) {
        console.log("POR EXTENSO");
        console.log(valor);

        if (formatacao == "moeda") {
          //valor = numero.porExtenso(Number(this.toNumber(valor)), numero.estilo.monetario);
          valor = numero.porExtenso(this.formatar02CasaDecimal(valor), numero.estilo.monetario);
        } else if (formatacao == "percentual") {
          valor = numero.porExtenso(valor, numero.estilo.porcentagem);
        } else if (formatacao == "ordinal masculino") {
          valor = this.numeroOrdinalPorExtensoGenero(valor, "masculino");
        } else if (formatacao == "ordinal feminino") {
          valor = this.numeroOrdinalPorExtensoGenero(valor, "feminino");
        } else {
          valor = numero.porExtenso(valor);
        }

        console.log("VALOR EXTENSO");
        console.log(valor);
      }

      if (nome_campo.includes("TtT") || nome_campo.includes("TTT")) {
        valor = valor.toUpperCase();
      }

      if (nome_campo.includes("ttt")) {
        valor = valor.toLowerCase();
      }

      //ANTIGO CÓDIGO TTT - EM VALIDAÇÃO

      /*

      if (uppercase && typeof valor == "string") {
        valor = valor.toUpperCase();
      }

      if (lowercase && typeof valor == "string") {
        valor = valor.toLowerCase();
      }
        */

      this.dados_json_para_docx[nome_campo] = valor;
    },

    localizar_tags(texto) {
      var tags = [];

      while (texto.search("\\${") != -1) {
        let pos_inicio = texto.search("\\${");
        let pos_fim = texto.search("}");

        let tag = texto.substring(pos_inicio + 2, pos_fim);
        tags.push(tag);

        texto = texto.substring(pos_fim + 1, texto.length);
      }

      console.log("Texto final");
      console.log(texto);

      return tags;
    },

    getModeloPath(modelo) {
      if (modelo.arquivo && modelo.arquivo.includes("rochaleiloes2")) {
        return process.env.MIX_VUE_APP_S3_BASE2_URL + modelo.arquivo;
      } else if ((modelo.arquivo && modelo.arquivo.includes("rochaleiloes")) || (modelo.arquivo && modelo.arquivo.includes("fotos_"))) {
        return process.env.MIX_VUE_APP_S3_BASE_URL + modelo.arquivo;
      } else {
        return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + modelo.arquivo;
      }
    },

    saveDoc(modelo, nota_venda, confirmado) {
      this.modelo_selecionado = modelo;
      this.nota_venda = nota_venda;

      console.log("NOTA? " + this.nota_venda);

      let url_arquivo = this.getModeloPath(modelo);

      let that = this;

      this.loadFile(url_arquivo, function (error, content) {
        if (error) {
          throw error;
        }
        const zip = new PizZip(content);
        const doc = new window.docxtemplater(zip, {
          delimiters: { start: "${", end: "}" },
          paragraphLoop: true,
          linebreaks: true,
        });

        //console.log("Textooo");
        //console.log(doc.getFullText());

        let json = that.gerarJsonDados(doc.getFullText());

        console.log("Tags não encontradas?");
        console.log(that.tags_nao_encontradas.length);

        let show_confirmation = false;
        let html = "";

        if (that.tags_nao_encontradas.length) {
          if (that.tags_nao_encontradas.length == 1) {
            html = "A tag " + that.tags_nao_encontradas[0] + " não foi substituida, deseja continuar mesmo assim?";
          } else {
            html = "As tags: <b>" + that.tags_nao_encontradas[0] + "<br/>";
            let i = 1;

            while (i <= 3) {
              if (i < that.tags_nao_encontradas.length) {
                html = html + that.tags_nao_encontradas[i] + "<br/>";
              }
              i++;
            }

            html = html + "</b>";

            if (that.tags_nao_encontradas.length > 3) {
              html = html + "entra outras...<br/>";
            }

            html = html + "<br/>Não foram substituidas. Deseja continuar mesmo assim?";
          }

          show_confirmation = true;
        }

        doc.render(json);

        const blob = doc.getZip().generate({
          type: "blob",
          mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          // compression: DEFLATE adds a compression step.
          // For a 50MB output document, expect 500ms additional CPU time
          compression: "DEFLATE",
        });

        if (confirmado) {
          that.sendFileS3(blob);
        } else if (show_confirmation) {
          that.$swal
            .fire({
              title: "Ops...",
              icon: "error",
              showCancelButton: true,
              cancelButtonText: "Cancelar",
              confirmButtonColor: "#4caf50",
              cancelButtonColor: "#d33",
              confirmButtonText: "Sim!",
              html: html,
            })
            .then((result) => {
              if (result.value) {
                //GERAR BLOB NOVAMENTE PRA PEGAR A NF
                if (nota_venda && !that.lotes.lote_nf) {
                  that.gerarNF(() => {
                    that.saveDoc(modelo, nota_venda, true);
                  });
                } else {
                  that.sendFileS3(blob);
                }
              }
            });
        } else {
          if (nota_venda) {
            if (!that.lotes.lote_nf) {
              that.gerarNF(() => {
                that.saveDoc(modelo, nota_venda, true);
              });
            } else {
              that.saveDoc(modelo, nota_venda, true);
            }
          } else {
            that.sendFileS3(blob);
          }
        }
      });
    },

    gerarNF(callback) {
      let data = {
        lote_id: this.lotes.id,
        nota_venda: this.nota_venda,
      };

      console.log("Atualizando NF");
      console.log(data);

      axios
        .post(`/admin/lote/update_nf`, data)
        .then((response) => {
          if (response.data.success) {
            console.log("NF GERADA " + response.data.lote_nf);
            console.log("NF ANTIGA " + this.lotes.lote_nf);

            this.lotes.lote_nf = response.data.lote_nf;

            callback();
          } else {
            this.showErrorMessageWithButton("Ops...", response.data.msg);
          }
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },

    store(file, callback) {
      // Output the document using Data-URI
      //saveAs(blob, "output.docx");

      let nome = "";

      if (this.processo) {
        nome = nome + "" + this.processo.processo_numero;
      }

      nome = nome + " - " + this.modelo_selecionado.tipo;

      if (this.arremate_praca) {
        nome = nome + " PRAÇA " + this.arremate_praca;
      }

      //let fileName = file.split("/");

      let data = {
        file: file,
        path: "rochaleiloes2/documentos_gerados/",
        tipo: this.modelo_selecionado.tipo,
        nome: nome,
        leiloeiro_id: 1,
        ref: this.modelo_selecionado.ref,
        lote_id: this.lotes.id,
        nota_venda: this.nota_venda,
      };

      console.log("Enviando agora");
      console.log(data);

      axios
        .post(`/admin/saved_docs/store`, data)
        .then((response) => {
          if (response.data.success) {
            this.showSuccessMessage("Documento salvo");
            this.buscarDocs();
          } else {
            this.showErrorMessageWithButton("Ops...", response.data.msg);
          }
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },

    sendFileS3(file) {
      const myFile = new File([file], "teste.docx", {
        type: file.type,
      });

      console.log("MY");
      console.log(myFile);
      console.log(file);
      console.log(file.type);

      return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append("id", "1");
        formData.append("path", "rochaleiloes2/documentos_gerados/");
        formData.append("file", myFile);

        console.log("Arquivo");
        console.log(file);

        axios
          .post(process.env.MIX_VUE_APP_UPLOAD_URL + `/s3/upload`, formData)
          .then((response) => {
            console.log(response.data);
            console.log("ENVIANDO PARA O BANCO\n");

            this.store(response.data.key);
          })
          .catch((error) => {
            console.log(error);
            this.isLoading = false;
            this.showErrorMessageWithButton("Ops..", error.response.data.error);
            reject();
          });
      });
    },

    cancelModal() {
      this.setGerarDocumento(false);
    },

    buscarModelos() {
      let data = {
        inicio: 0,
        tamanho: 200,
      };

      this.buscarDocs();

      console.log(data);

      axios
        .post(`/admin/modelos/documentos/search`, data)
        .then((response) => {
          this.modelos_docs = response.data.modelos_docs;

          this.modelos_auto_extra = [];
          this.modelos_auto_judicial = [];
          this.modelos_auto_negativos = [];
          this.modelos_nota_venda = [];
          this.modelos_processo = [];

          console.log("TEM LANCE?");
          console.log(this.lance);
          console.log(this.lotes);

          console.log("MODELOS");
          console.log(this.modelos_docs);

          if (this.lotes.users) {
            let casado = true;
            let pagamento_a_vista = this.lotes.cadastros.lote_ultimo_lance_parcelado == 1 ? true : false;

            //SE SOLTEIRO
            if (
              this.lotes.cadastros.estado_civil == "solteiro_sem_uniao_estavel" ||
              this.lotes.cadastros.estado_civil == "divorciado" ||
              this.lotes.cadastros.estado_civil == "separado_judicialmente" ||
              this.lotes.cadastros.estado_civil == "viuvo" ||
              this.lotes.cadastros.estado_civil == "solteiro"
            ) {
              casado = false;
            }

            console.log("POSSUI LANCE");
            console.log("Casado? " + casado);
            console.log("À vista? " + pagamento_a_vista);
            console.log("Cadastro tipo " + this.lotes.cadastros.cadastro_tipo);
            console.log("Lote tipo " + this.lotes.lote_tipo);
          }

          for (let i = 0; i < this.modelos_docs.length; i++) {
            //solteiro_sem_uniao_estavel','solteiro_com_uniao_estavel','uniao_estavel','casado',
            //'divorciado','separado_judicialmente','viuvo','solteiro'

            let match = false;

            let documento_casado = true;

            //DOCUMENTO SOLTEIRO
            if (
              this.modelos_docs[i].estado_civil == "solteiro_sem_uniao_estavel" ||
              this.modelos_docs[i].estado_civil == "divorciado" ||
              this.modelos_docs[i].estado_civil == "separado_judicialmente" ||
              this.modelos_docs[i].estado_civil == "viuvo" ||
              this.modelos_docs[i].estado_civil == "solteiro"
            ) {
              documento_casado = false;
            }

            if (this.lotes.users) {
              //console.log("ENTROU NO IF");

              let casado = true;
              let pagamento_a_vista = this.lotes.lote_ultimo_lance_parcelado == 1 ? false : true;

              //SE SOLTEIRO
              if (
                this.lotes.cadastros.estado_civil == "solteiro_sem_uniao_estavel" ||
                this.lotes.cadastros.estado_civil == "divorciado" ||
                this.lotes.cadastros.estado_civil == "separado_judicialmente" ||
                this.lotes.cadastros.estado_civil == "viuvo" ||
                this.lotes.cadastros.estado_civil == "solteiro"
              ) {
                casado = false;
              }

              let pagamento_a_vista_documento = this.modelos_docs[i].pagamento == "a_vista" ? true : false;

              if (
                (this.modelos_docs[i].comitente_id == this.leilao.comitente_id || !this.modelos_docs[i].comitente_id) &&
                (casado == documento_casado || !this.modelos_docs[i].estado_civil) &&
                (this.lotes.cadastros.cadastro_tipo == this.modelos_docs[i].tipo_cadastro || !this.modelos_docs[i].tipo_cadastro) &&
                (this.modelos_docs[i].tipo_lote == this.lotes.lote_tipo || !this.modelos_docs[i].tipo_lote) &&
                (pagamento_a_vista_documento == pagamento_a_vista || !this.modelos_docs[i].pagamento) &&
                (this.leilao.leilao_tipo == this.modelos_docs[i].tipo_leilao || !this.modelos_docs[i].tipo_leilao)
              ) {
                match = true;
                console.log("Deu match");
                console.log(this.modelos_docs[i]);
              }
              //ADICIONANDO POSSÍVEIS MATCHS
              let json_matchs = {};

              //ESTADO CIVIL
              if (this.modelos_docs[i].estado_civil) {
                json_matchs.estado_civil = documento_casado ? "CASADO" : "SOLTEIRO";
                json_matchs.estado_civil_class = casado == documento_casado ? "selected-autos" : "";
              }

              //TIPO CADASTRO
              if (this.modelos_docs[i].tipo_cadastro) {
                json_matchs.tipo_cadastro = this.modelos_docs[i].tipo_cadastro.toUpperCase();
                json_matchs.tipo_cadastro_class = this.modelos_docs[i].tipo_cadastro == this.lotes.cadastros.cadastro_tipo ? "selected-autos" : "";
              }

              //TIPO LOTE
              if (this.modelos_docs[i].tipo_lote) {
                json_matchs.tipo_lote = this.modelos_docs[i].tipo_lote == "imovel" ? "IMÓVEL" : "MÓVEL";
                json_matchs.tipo_lote_class = this.modelos_docs[i].tipo_lote == this.lotes.lote_tipo ? "selected-autos" : "";
              }

              //FORMA PAGAMENTO
              if (this.modelos_docs[i].pagamento) {
                json_matchs.pagamento = this.modelos_docs[i].pagamento == "a_vista" ? "À VISTA" : "PARCELADO";
                json_matchs.pagamento_class = pagamento_a_vista_documento == pagamento_a_vista ? "selected-autos" : "";
              }

              //TIPO LEILÃO
              if (this.modelos_docs[i].tipo_leilao) {
                json_matchs.tipo_leilao = this.modelos_docs[i].tipo_leilao == "extra" ? "EXTRAJUDICIAL" : "JUDICIAL";
                json_matchs.tipo_leilao_class = this.leilao.leilao_tipo == this.modelos_docs[i].tipo_leilao ? "selected-autos" : "";
              }

              //COMITENTE
              //json_matchs.tipo_leilao = this.modelos_docs[i].tipo_leilao == "extra" ? "EXTRAJUDICIAL" : "JUDICIAL";
              //json_matchs.tipo_leilao_class = this.leilao.leilao_tipo == this.modelos_docs[i].tipo_leilao ? "selected-autos" : "";

              this.modelos_docs[i].json_matchs = json_matchs;

              console.log("Casado doc? " + documento_casado);
              console.log("À vista? " + pagamento_a_vista_documento);
              console.log("Cadastro tipo " + this.modelos_docs[i].tipo_cadastro);
              console.log("Lote tipo " + this.modelos_docs[i].tipo_lote);
              console.log("\n\n");

              /*
              //SOLTEIRO A VISTA PF
              if (!casado && pagamento_a_vista && this.lance.cadastro_tipo == "pf" && this.modelos_docs[i].ref == "PF à vista") {
                let json_data = this.modelos_docs[i];
                json_data.class = "selected-autos";
                this.modelos_docs[i] = json_data;
              }

              //CASADO A VISTA PF
              if (casado && pagamento_a_vista && this.lance.cadastro_tipo == "pf" && this.modelos_docs[i].ref == "PF à vista casado") {
                let json_data = this.modelos_docs[i];
                json_data.class = "selected-autos";
                this.modelos_docs[i] = json_data;
              }

              //SOLTEIRO PARCELADO PF
              if (!casado && !pagamento_a_vista && this.lance.cadastro_tipo == "pf" && this.modelos_docs[i].ref == "PF parcelado") {
                let json_data = this.modelos_docs[i];
                json_data.class = "selected-autos";
                this.modelos_docs[i] = json_data;
              }

              //CASADO PARCELADO PF
              if (casado && !pagamento_a_vista && this.lance.cadastro_tipo == "pf" && this.modelos_docs[i].ref == "PF parcelado casado") {
                let json_data = this.modelos_docs[i];
                json_data.class = "selected-autos";
                this.modelos_docs[i] = json_data;
              }

              //SELEÇÃO PJ

              //A VISTA PJ
              if (pagamento_a_vista && this.lance.cadastro_tipo == "pj" && this.modelos_docs[i].ref == "PJ à vista") {
                let json_data = this.modelos_docs[i];
                json_data.class = "selected-autos";
                this.modelos_docs[i] = json_data;
              }

              //CASADO PARCELADO PJ
              if (!pagamento_a_vista && this.lance.cadastro_tipo == "pj" && this.modelos_docs[i].ref == "PJ parcelado") {
                let json_data = this.modelos_docs[i];
                json_data.class = "selected-autos";
                this.modelos_docs[i] = json_data;
              }
                */
            } else {
              //ADICIONANDO POSSÍVEIS MATCHS
              let json_matchs = {};

              //ESTADO CIVIL
              if (this.modelos_docs[i].estado_civil) {
                json_matchs.estado_civil = documento_casado ? "CASADO" : "SOLTEIRO";
              }

              //TIPO CADASTRO
              if (this.modelos_docs[i].tipo_cadastro) {
                json_matchs.tipo_cadastro = this.modelos_docs[i].tipo_cadastro.toUpperCase();
              }

              //TIPO LOTE
              if (this.modelos_docs[i].tipo_lote) {
                json_matchs.tipo_lote = this.modelos_docs[i].tipo_lote == "imovel" ? "IMÓVEL" : "MÓVEL";
              }

              //FORMA PAGAMENTO
              if (this.modelos_docs[i].pagamento) {
                json_matchs.pagamento = this.modelos_docs[i].pagamento == "a_vista" ? "À VISTA" : "PARCELADO";
              }

              //TIPO LEILÃO
              if (this.modelos_docs[i].tipo_leilao) {
                json_matchs.tipo_leilao = this.modelos_docs[i].tipo_leilao == "extra" ? "EXTRAJUDICIAL" : "JUDICIAL";
              }

              this.modelos_docs[i].json_matchs = json_matchs;

              console.log("MODEL SEM LANCE");
              console.log(this.modelos_docs[i]);
            }

            /*
            if (this.modelos_docs[i].tipo == "Auto extrajudicial") {
              this.modelos_auto_extra.push(this.modelos_docs[i]);
            } else if (this.modelos_docs[i].tipo == "Auto judicial") {
              this.modelos_auto_judicial.push(this.modelos_docs[i]);
            } else if (this.modelos_docs[i].tipo == "Negativo") {
              this.modelos_auto_negativos.push(this.modelos_docs[i]);
            } else if (this.modelos_docs[i].tipo == "Nota de venda") {
              this.modelos_nota_venda.push(this.modelos_docs[i]);
            } else if (this.modelos_docs[i].tipo == "Processo") {
              this.modelos_processo.push(this.modelos_docs[i]);
            }
              */

            if (this.modelos_docs[i].tipo == "Auto extrajudicial") {
              if (match) {
                let json_data = this.modelos_docs[i];
                json_data.class = "selected-autos";
                this.modelos_docs[i] = json_data;
                this.modelos_auto_extra.push(this.modelos_docs[i]);
              } else {
                console.log("ELSE");
                console.log(this.modelos_docs[i]);
                this.modelos_auto_extra_nao_coincidentes.push(this.modelos_docs[i]);
              }
            } else if (this.modelos_docs[i].tipo == "Auto judicial") {
              if (match) {
                let json_data = this.modelos_docs[i];
                json_data.class = "selected-autos";
                this.modelos_docs[i] = json_data;
                this.modelos_auto_judicial.push(this.modelos_docs[i]);
              } else {
                this.modelos_auto_judicial_nao_coincidentes.push(this.modelos_docs[i]);
              }
            } else if (this.modelos_docs[i].tipo == "Negativo") {
              if (match) {
                let json_data = this.modelos_docs[i];
                json_data.class = "selected-autos";
                this.modelos_docs[i] = json_data;
                this.modelos_auto_negativos.push(this.modelos_docs[i]);
              } else {
                this.modelos_auto_negativos_nao_coincidentes.push(this.modelos_docs[i]);
              }
            } else if (this.modelos_docs[i].tipo == "Nota de venda") {
              if (match) {
                let json_data = this.modelos_docs[i];
                json_data.class = "selected-autos";
                this.modelos_docs[i] = json_data;
                this.modelos_nota_venda.push(this.modelos_docs[i]);
              } else {
                this.modelos_nota_venda_nao_coincidentes.push(this.modelos_docs[i]);
              }
            } else if (this.modelos_docs[i].tipo == "Processo") {
              if (match) {
                let json_data = this.modelos_docs[i];
                json_data.class = "selected-autos";
                this.modelos_docs[i] = json_data;
                this.modelos_processo.push(this.modelos_docs[i]);
              } else {
                this.modelos_processo_nao_coincidentes.push(this.modelos_docs[i]);
              }
            }
          }
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },

    buscarProposta() {
      this.isLoading = true;

      let data = {
        lote_id: this.lote_id,
        praca: this.lotes.lote_lance_praca,
        user_id: this.lotes.lote_lance_user_id,
      };

      axios
        .post(`/admin/proposta/find`, data)
        .then((response) => {
          this.form_proposta = response.data.proposta;

          console.log("PROPOSTA ENCONTRADA");
          console.log(this.form_proposta);

          if (this.form_proposta) {
            this.valor_entrada_calculado = this.formatar02CasaDecimal((this.lotes.lote_lance * this.form_proposta.pct_entrada) / 100);
            this.valor_saldo_calculado = this.formatar02CasaDecimal(this.lotes.lote_lance - this.valor_entrada_calculado);
            this.valor_parcela_calculado = this.formatar02CasaDecimal(this.valor_saldo_calculado / this.form_proposta.parcelas);

            this.form_proposta.valor_proposta_formatado = this.toCurrency(this.form_proposta.valor_proposta);

            this.num_parcelas = this.form_proposta.parcelas;
            this.pct_entrada = this.form_proposta.pct_entrada;
          }
        })
        .catch((error) => {
          console.log(error);
          this.showErrorMessageWithButton("Ops..", error);
          this.isLoading = false;
        });
    },

    buscarLote(cb) {
      this.isLoading = true;

      let data = {
        lote_id: this.lote_id,
      };

      axios
        .post(`/admin/lote/find_by_id`, data)
        .then((response) => {
          this.lotes = response.data.lote;

          console.log("Lote selecionado");
          console.log(this.lotes.id);
          console.log(this.lotes);

          this.isLoading = false;
          cb();
        })
        .catch((error) => {
          console.log(error);
          this.showErrorMessageWithButton("Ops..", error);
          this.isLoading = false;
        });
    },

    buscarLances() {
      this.lances = [];

      let data = {
        praca: this.arremate_praca,
        tamanho: 10,
        lote_id: this.lote_id,
        with_trashed: false,
      };

      console.log("Buscando lances");
      console.log(data);

      axios
        .post(`/admin/lances/search`, data)
        .then((response) => {
          this.lances = response.data.lances;
          this.total_lances_indice = response.data.total;

          for (let i = 0; i < this.lances.length; i++) {
            this.lances[i].nome_tag = this.getPrefix(this.lances[i]);
          }

          console.log("Lances");
          console.log(this.lances);

          console.log("COMPARANDO " + this.lotes.lote_lance_user_id);

          if (this.lances.length) {
            //this.lance = this.lances[0];

            let indice = this.lances.findIndex((element) => element["lote_lance_user_id"] == this.lotes.lote_lance_user_id);

            this.segundo_lance = this.lances[1];

            if (this.segundo_lance) {
              this.segundo_lance_valor = this.segundo_lance.valor;

              if (this.segundo_lance.user_cadastros.cadastro_tipo == "pj") {
                this.segundo_lance.user_cadastros.cpf_cnpj = this.segundo_lance.user_cadastros.pj_cnpj;
                this.segundo_lance.user_cadastros.nome_completo_razao_social = this.segundo_lance.user_cadastros.pj_razao_social;
              }

              if (this.segundo_lance.user_cadastros.cadastro_tipo == "pf") {
                this.segundo_lance.user_cadastros.cpf_cnpj = this.segundo_lance.user_cadastros.cpf;
                this.segundo_lance.user_cadastros.nome_completo_razao_social = this.segundo_lance.user_cadastros.nome_completo;
              }
            } else {
              this.segundo_lance_valor = "NÃO HOUVE";

              this.segundo_lance = {
                valor: " ",
                user_cadastros: {
                  nome: "NÃO HOUVE",
                  cpf: " ",
                  cpf_cnpj: " ",
                  nome_completo: "NÃO HOUVE",
                  nome_completo_razao_social: " ",
                },
              };
            }

            if (indice >= 0) {
              console.log("Lance");
              this.lance = this.lances[indice];
              this.changeValor();
            } else {
              console.log("Não achou lance");
            }
          } else {
            this.segundo_lance_valor = "NÃO HOUVE";

            this.segundo_lance = {
              valor: " ",
              user_cadastros: {
                nome: "NÃO HOUVE",
                cpf: " ",
                cpf_cnpj: " ",
                nome_completo: "NÃO HOUVE",
                nome_completo_razao_social: " ",
              },
            };
          }

          this.buscarModelos();
          this.buscarUsuario();
        })
        .catch((error) => {
          console.log(error);

          if (typeof error == "object") {
            if (error.response.status == "403") {
              this.showErrorMessageWithButtonAndReload("Ops...", "Você precisa estar logado para importar lotes.");
            } else {
              this.showErrorMessageWithButton("Ops..", "Houve um problema com a sua solicitação. Verifique o documento e tente novamente.");
            }
          } else {
            this.showErrorMessageWithButtonAndReloadIfConfirm("Ops..", "Houve um problema com a sua solicitação. Clique em OK para atualizar a tela");
          }
        });
    },

    buscarUsuario() {
      if (this.lotes.lote_lance_user_id) {
        let data = {
          user_id: this.lotes.lote_lance_user_id,
        };

        axios
          .post(`/admin/user_cadastros/find`, data)
          .then((response) => {
            console.log("USUÁRIO DO LOTE");
            console.log(data);
            this.user_profile = response.data.user_cadastro;
          })
          .catch((error) => {
            console.log(error);
            this.showErrorMessageWithButton("Ops..", error);
            this.isLoading = false;
          });
      }
    },

    buscarVariaveisDocumentos() {
      this.variaveis_documentos = [];

      axios
        .post(`/admin/variaveis_documentos/search`)
        .then((response) => {
          this.variaveis_documentos = response.data.variaveis_documentos;
        })
        .catch((error) => {
          console.log(error);
          this.showErrorMessageWithButton("Ops..", error);
          this.isLoading = false;
        });
    },

    buscarDocs() {
      this.saved_docs = [];

      let data = {
        lote_id: this.lotes.id,
        inicio: 0,
        tamanho: 200,
      };

      console.log(data);

      axios
        .post(`/admin/saved_docs/search`, data)
        .then((response) => {
          this.saved_docs = response.data.saved_docs;
        })
        .catch((error) => {
          console.log(error);
          this.showErrorMessageWithButton("Ops..", error);
          this.isLoading = false;
        });
    },

    getDocPath(modelo) {
      if (modelo.arquivo && modelo.arquivo.includes("rochaleiloes2")) {
        return process.env.MIX_VUE_APP_S3_BASE2_URL + modelo.arquivo;
      } else if ((modelo.arquivo && modelo.arquivo.includes("rochaleiloes")) || (modelo.arquivo && modelo.arquivo.includes("fotos_"))) {
        return process.env.MIX_VUE_APP_S3_BASE_URL + modelo.arquivo;
      } else {
        return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + modelo.arquivo;
      }
    },

    deletarDoc(modelo) {
      this.$swal
        .fire({
          title: "<h3 style='color:#616060'>Deseja deletar o documento<b><br/>" + modelo.nome + "</b>? </h3>",
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero deletar!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              id: modelo.id,
            };

            axios
              .post(`/admin/saved_docs/delete`, data)
              .then((response) => {
                //DELETANDO ARQUIVO
                let data = {
                  path: modelo.arquivo,
                };

                console.log("DELETANDO S3");
                console.log(data);

                axios
                  .post(process.env.MIX_VUE_APP_UPLOAD_URL + `/s3/delete-file`, data)
                  .then((response) => {})
                  .catch((error) => {
                    console.log(error);
                    this.isLoading = false;
                    this.showErrorMessageWithButton("Ops..", error);
                  });

                this.showSuccessMessage("Documento deletado!");
                this.buscarDocs();
              })
              .catch((error) => {
                this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                console.log(error.response.data);
              });
          }
        });
    },

    validateFields() {
      if (!this.nome) {
        this.showErrorMessageWithButton("Ops...", "O campo nome é obrigatório!");
      } else {
        this.create();
      }
    },

    formatOnlyDate(date) {
      return moment(new Date(date)).format("DD/MM/YYYY");
    },

    getOnlyYear(date) {
      return moment(new Date(date)).tz("America/Sao_Paulo").format("YYYY");
    },

    getOnlyYearExtenso(date) {
      let ano = moment(new Date(date)).tz("America/Sao_Paulo").format("YYYY");

      return numero.porExtenso(ano);
    },

    getOnlyMonth(date) {
      let data = moment(date).format("YYYY-MM-DD");

      return moment
        .utc(data + "T12:00:00Z")
        .tz("America/Sao_Paulo")
        .format("MM");
    },

    getOnlyMonthExtenso(date) {
      let data = moment(date).format("YYYY-MM-DD");

      return moment
        .utc(data + "T12:00:00Z")
        .tz("America/Sao_Paulo")
        .locale("pt-br")
        .format("MMMM");
    },

    getOnlyDay(date) {
      return moment(new Date(date)).tz("America/Sao_Paulo").format("DD");
    },

    getOnlyDayExtenso(date) {
      let dia = moment(new Date(date)).tz("America/Sao_Paulo").format("DD");

      return numero.porExtenso(dia);
    },

    getOnlyTime(date) {
      return moment(date).format("HH:mm");
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY - HH:mm");
    },

    formatDateTime(date) {
      return moment(date).format("DD/MM/YYYY - HH:mm:ss");
    },
  },
};
</script>

<style scoped>
.destaque {
  border-color: green;
  border-radius: 3px !important;
}

.selected-autos {
  color: green;
  font-weight: bold;
}

.span-green {
  background-color: green;
}

.span-grwy {
  background-color: gray;
}

.modal-content {
  width: 1700px;
  margin-left: -530px;
}

@media screen and (max-width: 2000px) {
  .modal-content {
    width: 1400px;
    margin-left: -430px;
  }
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 1200px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 1100px) {
  .modal-content {
    width: 600px;
    margin-left: -20px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 960px) {
  .modal-content {
    width: 750px;
    margin-left: -120px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
  }
}
</style>
